import { CheckCircleOutlined } from '@mui/icons-material';
import { Box, Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Typography as UITypography } from '@peritasai/ui-components';
import { periverseTheme, themeShape } from '@peritasai/ui-shared';
import React from 'react';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: themeShape.borderRadius.medium,
    maxWidth: '400px',
    width: '100%',
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const SuccessIconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  fontSize: '3rem',
}));

const SuccessText = styled(UITypography)(({ theme }) => ({
  textAlign: 'center',
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: '1.25rem',
  color: theme.palette.text.primary,
}));

export interface CartRemovalSuccessDialogProps {
  open: boolean;
}

export const CartRemovalSuccessDialog: React.FC<
  CartRemovalSuccessDialogProps
> = ({ open }) => {
  return (
    <StyledDialog
      open={open}
      maxWidth="xs"
      fullWidth
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: '#E5E5E5',
            opacity: 1,
          },
        },
      }}
    >
      <SuccessIconContainer>
        <CheckCircleOutlined
          sx={{
            fontSize: '3rem',
            color: periverseTheme.palette.success.main,
          }}
        />
      </SuccessIconContainer>
      <SuccessText variant="h6">Cart Removed</SuccessText>
    </StyledDialog>
  );
};

